import { type LocaleName } from '@solinkcorp/locale';
import { DEFAULT_LOCALE } from '@solinkcorp/vd-common';
import LocaleUtil from 'utils/LocaleUtil';
import { makeImmerReducer } from './utils';

// This locale will be overwritten when the user logs in below, but this is used
// to set up something reasonable mainly for unit tests.
const localeCode: LocaleName = DEFAULT_LOCALE;

export interface LocaleState {
  localeCode: LocaleName;
}

export const initialState: LocaleState = {
  localeCode,
};

export const localeReducer = makeImmerReducer(initialState, (draft, action) => {
  switch (action.type) {
    case 'UPDATE_LOCALE': {
      const localeCode = action.localeCode;
      if (localeCode && LocaleUtil.isSupportedLocale(localeCode)) {
        draft.localeCode = localeCode;
      }
      break;
    }
  }
});
